module.exports = __webpack_public_path__ + "static/media/industrial-shields.c69a93fb.svg";